import React from 'react';
import { YM_COUNTER_ID } from '../services/api';

declare global {
  interface Window {
    ym?: (...args: any[]) => void;
  }
}

function getCounterId(): number | null {
  const raw = `${YM_COUNTER_ID || ''}`.trim();
  const n = Number.parseInt(raw, 10);
  return Number.isFinite(n) && n > 0 ? n : null;
}

function ensureMetrikaLoaded(counterId: number) {
  const w = window as any;
  if (w.__ym_loaded) return;
  w.__ym_loaded = true;

  w.ym =
    w.ym ||
    function () {
      (w.ym.a = w.ym.a || []).push(arguments);
    };
  w.ym.l = Number(new Date());

  const src = `https://mc.yandex.ru/metrika/tag.js?id=${counterId}`;
  if (!Array.from(document.scripts).some((s) => s.src === src)) {
    const script = document.createElement('script');
    script.async = true;
    script.src = src;
    document.head.appendChild(script);
  }

  w.ym(counterId, 'init', {
    ssr: true,
    webvisor: true,
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    ecommerce: 'dataLayer',
    referrer: document.referrer,
    url: window.location.href,
  });
}

export default function YandexMetrika() {
  React.useEffect(() => {
    const counterId = getCounterId();
    if (!counterId) return;
    ensureMetrikaLoaded(counterId);
  }, []);

  return null;
}

